import { render, staticRenderFns } from "./Atendimentos.vue?vue&type=template&id=062481bc&class=cor-fundo-atendimento&"
import script from "./Atendimentos.vue?vue&type=script&lang=js&"
export * from "./Atendimentos.vue?vue&type=script&lang=js&"
import style0 from "./Atendimentos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports